import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TextInput } from '..';
import { Search, XCircle } from '@talismn/web-icons';
import { forwardRef, useImperativeHandle, useRef } from 'react';
const SearchBar = forwardRef((props, ref) => {
    const innerRef = useRef(null);
    const hasValue = props.value?.toString().trim() !== '';
    useImperativeHandle(ref, () => 
    // @ts-expect-error
    innerRef.current);
    return (_jsx(TextInput, { ref: innerRef, ...props, leadingIcon: _jsx(Search, { size: "1em" }), trailingIcon: _jsx(XCircle, { size: "1em", css: [
                { cursor: 'pointer', transition: 'ease 0.5s' },
                !hasValue && {
                    transform: 'translateX(50%)',
                    opacity: 0,
                    pointerEvents: 'none',
                },
            ], onClick: () => {
                if (innerRef.current !== null) {
                    Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set?.call(innerRef.current, '');
                    innerRef.current.dispatchEvent(new Event('input', { bubbles: true }));
                    innerRef.current.focus();
                }
            } }) }));
});
export default SearchBar;
//# sourceMappingURL=SearchBar.js.map